import React, { useState, useEffect } from "react";
import axios from "axios";
import { GlobalSet } from "../../global/GlobalProvider";
import { useTranslation } from "react-i18next";

const BasicDatatable = () => {
  const { t } = useTranslation();
  const { CurrencySymbol } = GlobalSet();

  /* ================= STATES ================= */
  const [income, setIncome] = useState([]);
  const [pagination, setPagination] = useState({
    current_page: 1,
    last_page: 1,
    per_page: 20,
    total: 0,
  });
  const [loading, setLoading] = useState(false);

  /* ================= API CALL ================= */
  const fetchIncome = (page = 1) => {
    const selectedCurrency = localStorage.getItem("selectedCurrency");
    const auth_token = localStorage.getItem("auth_token");
    if (!auth_token) return;

    setLoading(true);

    axios
      .post(`/apps-income-history?page=${page}`, {
        key_s: "eyJ0eXAiOiJKV1Qidfg%!#%$%LCdf#*&*JhbGciOiJSUzI1NiJ9",
        currency: selectedCurrency,
      })
      .then((res) => {
        if (res.data.status === "success") {
          setIncome(res.data.data || []);
          setPagination(
            res.data.pagination || {
              current_page: 1,
              last_page: 1,
              per_page: 20,
              total: 0,
            }
          );
        }
      })
      .catch((err) => console.log(err))
      .finally(() => setLoading(false));
  };

  /* ================= FIRST LOAD ================= */
  useEffect(() => {
    fetchIncome(1);
  }, []);

  /* ================= PAGINATION WINDOW (5) ================= */
  const getPageNumbers = () => {
    const total = pagination.last_page;
    const current = pagination.current_page;
    const windowSize = 5;

    let start = Math.max(1, current - Math.floor(windowSize / 2));
    let end = start + windowSize - 1;

    if (end > total) {
      end = total;
      start = Math.max(1, end - windowSize + 1);
    }

    const pages = [];
    for (let i = start; i <= end; i++) {
      pages.push(i);
    }
    return pages;
  };

  return (
    <div className="col-12">
      <div className="card">
        <div className="card-header">
          <h4 className="card-title">
            {t("pro_IncHis_inc_his")}
          </h4>
        </div>

        <div className="card-body">
          <div className="table-responsive">
            <table className="table table-bordered w-100">
              <thead>
                <tr>
                  <th>{t("pro_IncHis_type")}</th>
                  <th>{t("pro_IncHis_amount")}</th>
                  <th>To Username</th>
                  <th>Level</th>
                  <th>{t("pro_IncHis_date")}</th>
                </tr>
              </thead>

              <tbody>
                {loading ? (
                  <tr>
                    <td colSpan="3" className="text-center">
                      Loading...
                    </td>
                  </tr>
                ) : income.length > 0 ? (
                  income.map((row) => (
                    <tr key={row.income_Id}>
                      <td>{row.income_Type}</td>
                      <td>
                        {row.income_Type === "BRISE Earning" ||
                        row.income_Type === "BRISE Genaration"
                          ? "BRISE "
                          : CurrencySymbol}
                        {row.income_Amount}
                      </td>
                      <td>{row.to_user_name}</td>
                      <td>{row.generation}</td>
                      <td>{row.date}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="3" className="text-center">
                      No data found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>

            {/* ================= INFO + PAGINATION ================= */}
            <div className="d-flex justify-content-between align-items-center mt-3">
              <div>
                Showing{" "}
                {pagination.total === 0
                  ? 0
                  : (pagination.current_page - 1) *
                      pagination.per_page +
                    1}{" "}
                to{" "}
                {Math.min(
                  pagination.current_page * pagination.per_page,
                  pagination.total
                )}{" "}
                of {pagination.total} entries
              </div>

              <div>
                {/* Previous */}
                <button
                  className="btn btn-sm btn-light me-2"
                  disabled={pagination.current_page === 1}
                  onClick={() =>
                    fetchIncome(pagination.current_page - 1)
                  }
                >
                  ‹
                </button>

                {/* Page Numbers (MAX 5) */}
                {getPageNumbers().map((page) => (
                  <button
                    key={page}
                    className={`btn btn-sm me-1 ${
                      pagination.current_page === page
                        ? "btn-primary"
                        : "btn-light"
                    }`}
                    onClick={() => fetchIncome(page)}
                  >
                    {page}
                  </button>
                ))}

                {/* Next */}
                <button
                  className="btn btn-sm btn-light"
                  disabled={
                    pagination.current_page ===
                    pagination.last_page
                  }
                  onClick={() =>
                    fetchIncome(pagination.current_page + 1)
                  }
                >
                  ›
                </button>
              </div>
            </div>
            {/* ================= END ================= */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BasicDatatable;
